import AbstractMarker, { DataToCreate } from './abstract-marker';

class NagataStation extends AbstractMarker {

  constructor(data: DataToCreate) {
    super({ ...data, coordinates: new google.maps.LatLng({ lat: 34.678720, lng: 135.591913 }) } );
  }

}

export default NagataStation;